<ion-content class="ion-padding" [hidden]="sso?.redirect?.enabled && !overrideLogin">
  <div class="login-container">
    <ion-grid>
      <ion-row>
        <ion-col size="12" size-md="6">
          <form class="form" [formGroup]="formGroup">
            <h1>{{ 'login.welcome' | translate | uppercase }}</h1>
            <h2>{{ 'login.doLogin' | translate }}</h2>

            <!-- Email-based SSO login -->
            <ng-container *ngIf="sso && !standardLogin">
              <mat-form-field class="login-input">
                <input matInput required
                       [placeholder]="'Digite seu email corporativo'"
                       formControlName="username"
                       type="email"
                       (keydown.enter)="loginWithAutoSso()" />
              </mat-form-field>
              <control-messages class="login-input" [control]="$any(formGroup.get('username'))"></control-messages>

              <div class="spacer"></div>
              <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
              <div class="spacer"></div>

              <a (click)="loginWithAutoSso()" style="cursor: pointer">
                <div class="button">
                  <ion-icon name="log-in-outline"></ion-icon>
                  <span>Login com SSO</span>
                </div>
              </a>

              <a class="standard-login" (click)="standardLogin = true" style="cursor: pointer">
                {{ 'login.standardLogin' | translate }}
              </a>
            </ng-container>

            <!-- Standard username/password login -->
            <ng-container *ngIf="standardLogin">
              <mat-form-field class="login-input">
                <input matInput required
                       [placeholder]="'login.username' | translate"
                       formControlName="username"
                       (keydown.enter)="doLogin()" />
              </mat-form-field>
              <control-messages class="login-input" [control]="$any(formGroup.get('username'))"></control-messages>

              <mat-form-field class="login-input">
                <input matInput type="password" required
                       [placeholder]="'generic.password' | translate"
                       formControlName="password"
                       (keydown.enter)="doLogin()" />
              </mat-form-field>
              <control-messages class="login-input" [control]="$any(formGroup.get('password'))"></control-messages>

              <a style="cursor: pointer" (click)="forgotPass()">
                {{ 'login.forgotPassword' | translate }}
              </a>

              <div class="spacer"></div>
              <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
              <div class="spacer"></div>

              <button type="button" (click)="doLogin()">
                {{ 'login.login' | translate }}
              </button>
            </ng-container>
          </form>
        </ion-col>
        <ion-col size="12" size-md="6">
          <div class="ilustration" [style.background-image]="'url(' + loginImgPath + ')'"></div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>
